import styled from 'styled-components';

export const List = styled.ul`
  display: inline-flex;
  list-style: none;
  padding: 2px;
  padding-bottom: 17px;
  overflow-x: auto;
`;

export const ListItem = styled.li`
  & + & {
    margin-left: 20px;
  }
`;
